<template>
  <div class="content">
    <div class="ad">
      <h3>登录前banner</h3>
      <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'beforeLoginImg')">
        <div v-if="param.beforeLoginImg" class="img f-c-c" :style="{ backgroundColor: param.beforeBackgroundColor }">
          <img :src="param.beforeLoginImg">
        </div>
        <div v-else class="f-c-c fd-c" style="height:100%">
          <i class="el-icon-plus avatar-uploader-icon" />
          <p>尺寸：1782x66</p>
          <p>大小不超过2M，格式JPG、PNG</p>
        </div>
      </el-upload>
      <div class="f-b-c">
        <div class="f--c">
          背景颜色：
          <el-color-picker v-model="param.beforeBackgroundColor"></el-color-picker>
        </div>
        <div class="f--c" style="color:#99C41C">
          <el-button type="text" size="medium" @click="change('beforeUpload')">更换图片</el-button>
          <!-- <el-button type="text" size="medium" @click="deleteImg('beforeLoginImg')" style="margin-left:20px">删除</el-button> -->
        </div>
      </div>
      <div class="f--c" style="margin-top:10px">跳转链接：
        <el-input v-model="param.beforeLoginLink" placeholder="请输入跳转链接" style="width:600px"></el-input>
      </div>
    </div>
    <div class="ad">
      <h3>登录后banner</h3>
      <el-upload ref="afterUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'afterLoginImg')">
        <div v-if="param.afterLoginImg" class="img f-c-c" :style="{ backgroundColor: param.afterBackgroundColor }">
          <img :src="param.afterLoginImg">
        </div>
        <div v-else class="f-c-c fd-c" style="height:100%">
          <i class="el-icon-plus avatar-uploader-icon" />
          <p>尺寸：1782x66</p>
          <p>大小不超过2M，格式JPG、PNG</p>
        </div>
      </el-upload>
      <div class="f-b-c">
        <div class="f--c">
          背景颜色：
          <el-color-picker v-model="param.afterBackgroundColor"></el-color-picker>
        </div>
        <div class="f--c" style="color:#99C41C">
          <el-button type="text" size="medium" @click="change('afterUpload')">更换图片</el-button>
          <!-- <el-button type="text" size="medium" @click="deleteImg('afterLoginImg')" style="margin-left:20px">删除</el-button> -->
        </div>
      </div>
      <div class="f--c" style="margin-top:10px">跳转链接：
        <el-input v-model="param.afterLoginLink" placeholder="请输入跳转链接" style="width:600px"></el-input>
      </div>
    </div>
    <div class="f-c-c">
      <el-button type="primary" :loading="loading" @click="submit">提交</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
let default_param = {
  beforeBackgroundColor: '#1A1717',
  afterBackgroundColor: '#1A1717',
}
export default {
  data() {
    return {
      param: _.cloneDeep(default_param),
      origin: _.cloneDeep(default_param),
      loading: false
    }
  },
  created() {
    this.getProductAdBar()
  },
  methods: {
    // 上传
    beforeUpload(file, type) {
      API.signValue({ directory: 'advertising/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'advertising/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.$set(this.param, type, result.data)
        })
      })
      return false
    },
    change(type) {
      this.$refs[type].$children[0].$el.click()
    },
    // 获取广告栏
    getProductAdBar() {
      API.getProductAdBar().then(res => {
        this.param = res.data || _.cloneDeep(default_param)
        this.origin = _.cloneDeep(res.data)
      })
    },
    deleteImg(type) {
      this.$set(this.param, type, '')
    },
    submit() {
      let params = this.param
      if (!params.beforeBackgroundColor) params.beforeBackgroundColor = default_param.beforeBackgroundColor
      if (!params.afterBackgroundColor) params.afterBackgroundColor = default_param.afterBackgroundColor
      if (!params.beforeLoginImg || !params.afterLoginImg) {
        return this.$message.error('请上传图片')
      }
      this.loading = true
      API.setProductAdBar(params).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success('提交成功')
        this.getProductAdBar()
      }).finally(() => {
        this.loading = false
      })
    },
    cancel() {
      this.$set(this.$data, 'param', _.cloneDeep(this.origin))
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 30px 20px;
  min-width: 1000px;

  .ad {
    margin-bottom: 30px;
    .upload-img {
      width: 100%;
      height: 150px;
      border: 1px dotted #999;
      margin: 20px 0;
      /deep/ .el-upload {
        width: 100%;
        height: 100%;
        display: block;
        .avatar-uploader-icon {
          font-size: 30px;
          font-weight: bold;
        }
      }
      .img {
        height:100%;
        img{
          width: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>